module.exports = __webpack_public_path__ + "static/media/wallet.1a72e9f4.svg";